<script setup lang="ts">
import SingleMember from './career-teamMemberDrawer/career-teamMemberDrawer.vue'

import type { IProps } from '~/domains/career/components/career-teamWithHeader/career-teamWithHeader.types'

const { drawerContent, version = 'primary' } = defineProps<IProps>()

const activeDrawer = ref<number | null>(null)

const checkIsOpenDrawer = (index: number) => {
  return activeDrawer.value === index
}

const toggleActiveDrawer = (index: number) => {
  if (activeDrawer.value === index) {
    activeDrawer.value = null
  } else {
    activeDrawer.value = index
  }
}
</script>

<template>
  <div class="Drawer-With-Header">
    <div :class="['Drawer-With-Header__container', `Drawer-With-Header__container--${version}`]">
      <div :class="['Drawer-With-Header__wrapper', `Drawer-With-Header__wrapper--${version}`]">
        <div class="Drawer-With-Header__left-column">
          <UiHeader
            v-if="header"
            :header="header"
            position="left"
            header-size="h5"
            header-size-tablet="h5"
            header-size-mobile="h5"
          />

          <img
            v-if="drawerPhoto"
            :src="drawerPhoto"
          >
        </div>

        <div class="Drawer-With-Header__right-column">
          <div class="Drawer-With-Header__drawerWrapper">
            <SingleMember
              v-for="(drawer, index) in drawerContent"
              :key="drawer.header"
              :header="drawer.header"
              :description="drawer.description"
              :version="version"
              :is-open="checkIsOpenDrawer(index)"
              @clicked="toggleActiveDrawer(index)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.Drawer-With-Header {
  display: flex;
  justify-content: center;
  width: 100%;

  &__container {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 5.4rem 2.4rem 4rem 2.4rem;
    background-color: $gray-100;
    border-radius: 1.6rem;

    &--secondary {
      background-color: $white;
    }
  }
  &__wrapper {
    display: flex;
    flex-direction: column;
    max-width: 136rem;
    width: 100%;
  }

  &__left-column {
    margin: 0 0 3.2rem 0;
  }

  &__drawerWrapper {
    margin-bottom: 2.4rem;
  }
}

@include atM {
  .Drawer-With-Header {
    padding: 0 2rem;

    &__container {
      padding: 6rem 2rem;
    }

    &__wrapper {
      flex-direction: row;
      max-width: 136rem;
      margin: 0 auto;

      &--primary {
        justify-content: space-between;
      }

      &--secondary {
        justify-content: flex-start;
      }
    }

    &__left-column {
      max-width: 45rem;
      margin-right: 10rem;
    }

    &__right-column {
      max-width: 75rem;
      width: 70%;
    }

    &__drawerWrapper {
      margin-bottom: 8rem;
    }
  }
}
</style>
